import * as React from 'react';
import { Icon } from '../../uiComponents/Icon';
import { Button } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { Bruger } from '../../models/Bruger';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';
import { LogbogIndlaeg } from '../../models/LogbogIndlaeg';
import { Guid } from '../../infrastructure/Guid';

export interface LogbogIndlaegEditComponentProps {
    bruger: Bruger;
    createIndlaeg: any;
    logbogAfsnitId: string;
}

interface LogbogIndlaegEditComponentState {
    tekst: string;
    submitting: boolean;
    id: string;
}

export default class LogbogIndlaegEditComponent extends React.Component<LogbogIndlaegEditComponentProps,
    LogbogIndlaegEditComponentState> {

    constructor(props: LogbogIndlaegEditComponentProps) {
        super(props);

        this.state = {
            id: Guid.newGuid(),
            tekst: '',
            submitting: false
        };
    }

    componentDidMount() {
        let headerHeight = this.props.bruger.rolle === BrugerRolleEnum.Laerer ? 80 : 20;
        $('.textarea-wrapper textarea')
            .focus(function () {
                $(this)
                    .stop()
                    .animate({
                        height: 180
                    },       'normal');
                var $component = $(this).closest('.logbog-indlaeg-component');
                $component.addClass('expanded');
                var $topContent = $component.find('.logbog-indlaeg-component-top-content');

                $topContent.animate({
                    height: headerHeight
                },                  'normal');

                $topContent
                    .stop()
                    .animate({
                        opacity: 1
                    },       'normal');
            });
    }

    closeIndlaeg = () => {
        var $component = $('#' + this.state.id);
        var $topContent = $component.find('.logbog-indlaeg-component-top-content');
        var $textarea = $component.find('.textarea-wrapper textarea');

        $textarea.animate({
            height: 40
        },                'normal');

        $component.removeClass('expanded');

        $topContent
            .animate({
                opacity: 0
            },       'fast');

        $topContent.animate({
            height: 0
        },                  'normal');
    }

    getLaererHeader() {
        if (this.props.bruger.rolle === BrugerRolleEnum.Laerer) {
            return (
                <div className='logbog-indlaeg-component-top-content'>
                    <div className='user-card'>
                        <div className='user-card-circle'>
                            <Icon name='user' />
                        </div>
                        <p className='user-name'>{this.props.bruger.navn}</p>
                    </div>
                    <div className='close-icon-wrapper' onClick={this.closeIndlaeg}>
                        <Icon className='close-icon' name='close' />
                    </div>
                    <label>Skriv svar</label>
                </div>
            );
        } else {
            return (
                <div className='logbog-indlaeg-component-top-content'>
                    <div className='close-icon-wrapper' onClick={this.closeIndlaeg}>
                        <Icon className='close-icon' name='close' />
                    </div>
                    <label>Skriv svar</label>
                </div>
            );
        }
    }

    getClasses() {
        let classes = 'logbog-indlaeg-component';
        if (this.props.bruger.rolle === BrugerRolleEnum.Laerer) {
            classes += ' laerer';
        }

        return classes;
    }

    createLogbogIndlaeg = () => {
        this.setState({submitting: true});

        let indlaeg = new LogbogIndlaeg();
        indlaeg.brugerId = this.props.bruger.id;
        indlaeg.tekst = this.state.tekst;

        this.props.createIndlaeg(this.props.logbogAfsnitId, indlaeg)
            .then(() => {
                this.setState({ tekst: '', submitting: false });
                this.closeIndlaeg();
            });
    }

    onTekstChanged = (e: any) => {
        this.setState({ tekst: e.target.value });
    }

    getDisabled() {
        if (this.state.submitting) {
            return true;
        }

        return false;
    }

    render() {
        return (
            <div id={this.state.id} className={this.getClasses()}>
                {this.getLaererHeader()}

                <div className='textarea-wrapper'>
                    <textarea className='form-control' onChange={this.onTekstChanged} placeholder='Skriv svar' value={this.state.tekst} disabled={this.getDisabled()} />
                    <Icon name='edit' />
                </div>
                <Button className='logbog-indlaeg-component-button' buttonType='primary' buttonSize='md' onClick={this.createLogbogIndlaeg} disabled={this.getDisabled()}>
                    Tilføj svar
                </Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Logbog/LogbogIndlaegEditComponent.tsx